export function initHome() {

    console.log('Init Home');

    const body = document.querySelector('body');
    const menuToggle = document.querySelector('.menu__toggle');
    const filtersContainer = document.querySelector('.filters');
    const filtersHeadline = document.querySelector('.shows .headline h2');

    let menuOpen = false;

    var formFilters = $("#formFilters");
    var selectFilters = $("#selectFilters");

    var inputFilter = $("#inputFilter");
    var timerInput;

    var showAllBtn = $("#showAllBtn");


    showAllBtn.click(function (e) {
        e.preventDefault();
        applyFilters(true);
    });

    formFilters.submit(function (e) {
        e.preventDefault();
        applyFilters();
    });


    selectFilters.change(function (e) {
        var value = $(this).val();
        if (tags.indexOf(value) === -1) tags.push(value);
        var url = tags.join("-").toLowerCase();

        history.pushState('', '', '/themes/' + url);
        selectFilters.find("option#defaultOption").prop('selected', true);
        applyFilters();
    });

    timerInput = false;
    inputFilter.keyup(function () {
        clearTimeout(timerInput);
        selectFilters.find("option#defaultOption").prop('selected', true);
        timerInput = setTimeout(function () {
            keyword = inputFilter.val();
            applyFilters();
        }, 500);
    });

    // Filters
    function applyFilters(showAll = false) {
        $("body").css("cursor", "wait")
        var ajaxurl = formFilters.data("ajaxurl");

        if (showAll) {
            console.log("-- showAll --");
            tags = [];
            keyword = "";
        }

        $.ajax({
            url: ajaxurl,
            type: "POST",
            data: {
                showAll: showAll ? 1 : 0,
                tags: tags,
                s: keyword,
            },
            success: function (data) {

                $("body").css("cursor", "default");

                if ((keyword === "" && tags.length === 0) && !showAll ){
                    showAllBtn.show();
                } else {
                    showAllBtn.hide();
                }

                $(".videos__list").html(data);
                const videoLenght = $(".videos__list li").length;
                const emissiontxt = videoLenght > 1 ? "émissions" : "émission";

                if (showAll) {
                    console.log("-- showAll --");
                    filtersHeadline.innerHTML = `Découvrez les ${videoLenght} ${emissiontxt} <strong>Sur la Route</strong>`;
                    return;
                }

                if (tags.length || keyword !== "") {
                    if (tags) {
                        filtersHeadline.innerHTML = `${videoLenght} ${emissiontxt} sur le(s) thème(s)<br/>`;
                        tags.forEach((tag) => {

                            const tagElem = document.createElement('span');
                            tagElem.className = 'tag';
                            tagElem.innerHTML = `<span>${tag}</span><a href="#" class="tag__remove"><span>supprimer</span></a>`;
                            tagElem.tag = tag;

                            tagElem.querySelector('.tag__remove').addEventListener('click', removeTag);
                            filtersHeadline.appendChild(tagElem);

                        });
                    }
                    var bubble = document.getElementById("searchFilter");
                    if (keyword !== "") {
                        console.log("-- search bubble --");
                        if (!bubble) {
                            const tagElem = document.createElement('span');
                            tagElem.className = 'tag';
                            tagElem.innerHTML = `<span id="searchFilter">${keyword}</span><a href="#" class="tag__remove"><span>supprimer</span></a>`;
                            tagElem.tag = keyword;
                            tagElem.querySelector('.tag__remove').addEventListener('click', removeSearch);
                            filtersHeadline.appendChild(tagElem);
                        } else {
                            bubble.innerText = keyword;
                        }
                    } else {
                        if (bubble) bubble.remove();
                    }
                    return;

                } else {
                    console.log("-- rien --");

                    filtersHeadline.innerHTML = `Découvrez les dernières émissions <strong>Sur la Route</strong>`;
                    return;

                }


            },
            error: function () {
                $("body").css("cursor", "default")
            }
        })

    }

    function removeTag(e) {

        e.preventDefault();

        //Delete DOM Tag
        let item = e.currentTarget.parentNode;
        item.parentNode.removeChild(item);

        //Delete in Tags[]
        let tagIndex = tags.indexOf(item.tag);

        tags.splice(tagIndex, 1);

        console.log('Tag Deleted', {tags});

        applyFilters();

    }

    function removeSearch(e) {

        e.preventDefault();

        //Delete DOM Tag
        let item = e.currentTarget.parentNode;
        item.parentNode.removeChild(item);

        //Delete in Tags[]
        keyword = "";
        inputFilter.val("");

        console.log('Tag Deleted', {tags});

        applyFilters();

    }

    if (toRestore) restoreTags(toRestore);
    else applyFilters();

    function restoreTags(tagsarray) {
        var options = $("#selectFilters option");
        tagsarray.forEach(function (tag) {
            options.each(function () {
                var option_value = $(this).val().toLowerCase();
                if (option_value === tag){
                    tags.push( $(this).val() )
                }
            })
        })
        applyFilters();
    }
}




/*

document.addEventListener('click', (e) => {
  var isClickInside = filtersToggle.contains(e.target);
  if (!isClickInside && filtersToggle.Open) {
    filtersContainer.classList.toggle('openFilters');
    filtersToggle.Open = !filtersToggle.Open;
  }
})

//nav
const anchors = document.querySelectorAll('.anchor__link');
for (let links of anchors) {

  links.addEventListener('click', (e) => {

    e.preventDefault();

    let anchorTarget = document.querySelector(e.currentTarget.getAttribute("href"));
    let targetStyle = anchorTarget.currentStyle || window.getComputedStyle(anchorTarget);
    let targetTop = anchorTarget.offsetTop - parseInt(targetStyle.marginTop);
    TweenMax.to(window, 1.2, { scrollTo: { y: targetTop, autoKill: false }, ease: Power3.easeInOut });

    if (menuOpen) {
      var click = new Event('click');
      menuToggle.dispatchEvent(click);
    }

  })
}*/

/*  $(".filters__list .item a").click(function(e) {

    e.preventDefault();
    e.stopPropagation();

    var values = [];
    $(this).toggleClass("active")
    if ($(".filters__list .item .active").length > 0) {
      $(".filters__list .item .active").each(function() {
        values.push($(this).find(".txt").text());
      })
    }
    $("body").css("cursor", "wait")
    var ajaxurl = $(".filters__list").data("ajaxurl");
    $.ajax({
      url: ajaxurl,
      type: "POST",
      data: { offset: 0, filters: values },
      success: function(data) {
        $("body").css("cursor", "default")
        var data = $.parseJSON(data);
        $(".videos__list").html(data.html);
        if (data.left <= 0) $(".load__more").hide();
        else $(".load__more").show();
      },
      error: function() {
        $("body").css("cursor", "default")
      }
    })
  })

  $(".load__more").click(function(e) {

    e.preventDefault();
    var _this = $(this);
    var offset = $(".videos__list .item").length;

    var filters = [];
    $(this).toggleClass("active")
    if ($(".filters__list .item .active").length > 0) {
      $(".filters__list .item .active").each(function() {
        filters.push($(this).find(".txt").text());
      })
    }
    $.ajax({
      url: _this.data("ajaxurl"),
      type: "POST",
      data: { offset: offset, filters: filters },
      success: function(data) {
        var data = $.parseJSON(data);
        $(".videos__list").append(data.html);
        if (data.left <= 0) _this.hide();

      }
    })
  });*/

